import axios from 'axios';
import { verifyAuth } from '../../../../services/auth';

const ApiTimeOut = 20000;

const getAuthToken = async () => {
    let JWT_TOKEN: string | undefined = undefined;
    try {
        JWT_TOKEN = await verifyAuth();
        return JWT_TOKEN
    } catch (error) {
        console.log(error);
        return {
            success: false,
            errors: {
                General: ['Unfortunately you are not authorized to access the content'],
            },
        };
    };
};

const twinxClient = {
    get: async (url: string, cancelRequest: any = "") => {
        const token = await getAuthToken();
        const options = {timeout: ApiTimeOut, headers: { Authorization: `Bearer ${token}`}};
        return await axios.get(url, !token.errors && cancelRequest !== "" ? {cancelToken: cancelRequest, ...options } : options);
    },
    post: async (url: string, body: any) => {
        try {
            const token = await getAuthToken();
            return await axios.post(url, body, { timeout: ApiTimeOut, headers: { Authorization: `Bearer ${token}` } });
        } catch (error) {
            console.log(error);
        };
    },
    patch: async (url: string, body: any) => {
        try {
            const token = await getAuthToken();
            return await axios.patch(url, body, { timeout: ApiTimeOut, headers: { Authorization: `Bearer ${token}` } });
        } catch (error) {
            console.log(error);
        };
    }
};

export default twinxClient;
